import React from 'react';
import './LogaltyIframe.scss';

const LogaltyIframe = ({ contractUrl }) => {
    return (
        <div className="logalty-iframe-wrapper">
            <iframe src={contractUrl} title="Logalty" className="logalty-iframe" />
        </div>
    );
};

export default LogaltyIframe;
